import { render, staticRenderFns } from "./FormTambah.vue?vue&type=template&id=c4434162&scoped=true"
import script from "./FormTambah.vue?vue&type=script&lang=js"
export * from "./FormTambah.vue?vue&type=script&lang=js"
import style0 from "./FormTambah.vue?vue&type=style&index=0&id=c4434162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4434162",
  null
  
)

export default component.exports